module.exports = __webpack_public_path__ + "img/coins-04.aa54b168.svg";